/**
 * Filter bucket → DB value mapping (iter129 / dog-filter-fix).
 *
 * The catalogue accumulated several different value sets for the same logical
 * concept over time (Pitchup uses one vocabulary, OSM another, Claude
 * enrichment a third). This module is the single source of truth for the UI
 * chip values used in Browse.jsx + HomeSearchWidget.jsx → DB string values.
 *
 * Keep this file in sync with the bucket-expansion logic in server.py
 * (search for `_DOG_BUCKETS`, `_CAMPFIRE_BUCKETS`, `_SURFACE_BUCKETS`).
 */

/** Dogs — UK convention: dogs allowed unless explicitly banned.
 *  `ask` is by far the most common DB value (15.6k sites) and means
 *  "owner welcomes them, just call ahead". We treat it as positive. */
export const DOG_BUCKETS = {
  welcome: ["yes", "welcome", "ok", "free", "allowed", "ask"],
  charged: ["charged"],
  off_lead_area: ["off_lead_area"],
  none: ["no", "none"],
};

/** Campfires — "ask" is treated as fire-pit territory because pitched-up
 *  parks with ask-permission generally allow contained fires. */
export const CAMPFIRE_BUCKETS = {
  allowed: ["allowed", "open_fires", "yes"],
  firepits: ["firepits", "firepits_only", "fire_pits", "ask"],
  none: ["no", "none"],
};

/** Pitch surface — "mountain" and "cabin" are leftover from OSM ingest
 *  where a few sites were tagged with surface=hill or pitch_type=cabin
 *  instead of an actual surface. We bucket them sensibly so users don't
 *  miss matches. */
export const SURFACE_BUCKETS = {
  grass: ["grass", "mountain"],
  hardstanding: ["hardstanding", "cabin"],
  gravel: ["gravel"],
};

/** Returns true if the campsite's stored value is in any of the selected
 *  bucket keys for the given filter group. `value` can be a string or an
 *  array (some OSM imports stored arrays for pitch_surface). */
export function matchesBucket(buckets, selectedKeys, value) {
  if (!selectedKeys || selectedKeys.length === 0) return true;
  if (value == null) return false;
  const arr = Array.isArray(value) ? value : [value];
  for (const key of selectedKeys) {
    const allowed = buckets[key];
    if (!allowed) continue;
    for (const v of arr) {
      if (allowed.indexOf(v) >= 0) return true;
    }
  }
  return false;
}
